import { createFileRoute } from '@tanstack/react-router'
import { useLingui } from '@lingui/react/macro'
import { TakeABreakForm } from '@/features/take-a-break/take-a-break-form/take-a-break-form'
import { TertiaryPageLayout } from '@/routes/-tertiary-page-layout'
import { AccessControlsInfo } from '@/features/access-controls/access-controls-info'
import { AccessControlsType } from '@/features/access-controls/access-controls-type'

export const Route = createFileRoute(
  '/_app/your-play/access-controls/take-a-break',
)({
  component: AccessControlSelect,
})

function AccessControlSelect() {
  const { t } = useLingui()

  return (
    <TertiaryPageLayout
      headerText={t`Take a Break`}
      infoDrawerContent={
        <AccessControlsInfo selectedTab={AccessControlsType.TAKE_A_BREAK} />
      }
    >
      <TakeABreakForm />
    </TertiaryPageLayout>
  )
}
